export const ROUTE_STUDENT_ID = ":studentId";

export function routeStudent(schoolId: string, studentId: string, classroomId?: string): string {
    if(classroomId) {
        return `/school/${schoolId}/student/${studentId}/classroom/${classroomId}`;
    }
    return `/school/${schoolId}/student/${studentId}`;
}

export function routeStudentEdit(schoolId: string, studentId: string): string {
    return `/school/${schoolId}/student/${studentId}/edit`;
}

export function routeStudentImage(schoolId: string, studentId: string, source?: "Classroom" | "ClassroomStudentAdd", classroomId?: string): string {
    let query = "";
    if(source) {
        query += `?source=${source}&classroomId=${classroomId}`;
    }
    return `/school/${schoolId}/student/${studentId}/image${query}`;
}

export function routeStudentNew(schoolId: string, classroomId: string): string {
    return `/school/${schoolId}/classroom/${classroomId}/student/new`;
}

// export function routeStudentUserAdd(schoolId: string, studentId: string): string {
//     return `/school/${schoolId}/student/${studentId}/user/new`;
// }

// export function routeStudentImagesAdd(schoolId: string, studentId: string, classroomId?: string): string {
//     if(classroomId) {
//         return `/school/${schoolId}/student/${studentId}/classroom/${classroomId}/images/add`;
//     }
//     return `/school/${schoolId}/student/${studentId}/images/add`;
// }

